export class MedicalPrescriptionDocumentKey {
  private value: string = "";

  constructor(value: string = "") {
    this.value = value;
  }

  setValue(value: string): void {
    this.value = value;
  }

  getValue(): string {
    return this.value;
  }
}
